import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/App'
import { createAuthProvider } from '@/authProvider'
import { createSupabaseSource } from '@/data/source'
import { createScalesDataProvider } from '@/dataProvider'
import { createSupabase } from '@/lib/supabase'
import { supabaseConfigFor } from '@/lib/supabaseConfig'

export const main = (): void => {
  const rootElement = document.getElementById('root')
  if (!rootElement) throw new Error('Root element not found')

  const supabase = createSupabase(supabaseConfigFor(import.meta.env.MODE, import.meta.env))
  createRoot(rootElement).render(
    <StrictMode>
      <App dataProvider={createScalesDataProvider(createSupabaseSource(() => supabase))} authProvider={createAuthProvider(supabase)} />
    </StrictMode>,
  )
}
